import { render, staticRenderFns } from "./SourceCard.vue?vue&type=template&id=4522568d&scoped=true&"
import script from "./SourceCard.vue?vue&type=script&lang=js&"
export * from "./SourceCard.vue?vue&type=script&lang=js&"
import style0 from "./SourceCard.vue?vue&type=style&index=0&id=4522568d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4522568d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
